/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const getFlexMessage = (selectedFlexOption) => {
    // Get Flex Message from cart
    if (
        selectedFlexOption
        && selectedFlexOption.optionCode
        && selectedFlexOption.flexMsg
        && Object.keys(selectedFlexOption.flexMsg).length > 2
    ) {
        return selectedFlexOption.flexMsg[3];
    }
    return '';
};

export default {};
